
import { Button } from "@/components/ui/button";
import { CalendarClock, ExternalLink, PlusCircle } from "lucide-react";
import { Subscriber } from "@/types/subscription";

interface SubscriptionActionButtonsProps {
  subscriber: Subscriber;
  onSubscriptionChange: (id: string, updates: Partial<Subscriber>) => Promise<void>;
  onGrantAdminSubscription: (subscriber: Subscriber) => void;
}

export default function SubscriptionActionButtons({
  subscriber,
  onSubscriptionChange,
  onGrantAdminSubscription,
}: SubscriptionActionButtonsProps) {
  const handleExtend = () => {
    const suggestedDate = subscriber.expires_at || subscriber.subscription_end || '';
    const nextDate = window.prompt('Extend admin grant until (YYYY-MM-DD)', suggestedDate.slice(0, 10));
    if (!nextDate) {
      return;
    }

    onSubscriptionChange(subscriber.id, {
      expires_at: new Date(`${nextDate}T23:59:59`).toISOString(),
    });
  };

  const canGrantAdminSubscription = Boolean(
    subscriber.user_id && (subscriber.subscription_source === 'free' || !subscriber.subscription_source)
  );

  return (
    <>
      {subscriber.subscription_source === 'admin' && (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleExtend}
        >
          <CalendarClock className="mr-2 h-4 w-4" />
          <span>Extend admin grant</span>
        </Button>
      )}

      {subscriber.subscription_source === 'stripe' && (
        <Button
          variant="ghost"
          size="sm"
          disabled
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          <span>Managed in Stripe</span>
        </Button>
      )}

      {canGrantAdminSubscription && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onGrantAdminSubscription(subscriber)}
        >
          <PlusCircle className="mr-2 h-4 w-4" />
          <span>Grant admin subscription</span>
        </Button>
      )}

      {!subscriber.subscription_source && !canGrantAdminSubscription && (
        <Button
          variant="ghost"
          size="sm"
          disabled
        >
          <span>No subscription actions</span>
        </Button>
      )}
    </>
  );
}
